<div style="margin-bottom:15px" id="myCounter" class="clock" *ngIf="!!timerValue">
  <span [class]="almostDone()" [style.color]="areTenSecsRemainings?'white':'white'">
    <span *ngIf="timerValue.count < 0">+ </span>
    {{timerValue.hours|number:'2.0'}}:{{timerValue.minutes|number :'2.0'}}:{{timerValue.seconds|number :'2.0'}}
  </span>
  <span class="scoreDecay"
        *ngIf="timerValue.scoreMultiplier != null">&nbsp;(score x {{timerValue.scoreMultiplier|number:'0.1'}})</span>
</div>
